// PageAccessToggles — admin toggle grid for per-user page access.
// Extracted from App.jsx (C1 refactor, Phase 2d3a). Behavior-preserving:
// body is byte-identical to the former App.jsx declaration.
//
// Dependencies imported from already-extracted modules (no App.jsx coupling):
//   • ALL_PAGES -> ../utils.js
import { ALL_PAGES } from "../utils.js";

export function PageAccessToggles({ access, onChange }) {
  const toggle = key => {
    const current = access || ALL_PAGES.map(p => p.key);
    if (current.includes(key)) {
      if (current.length <= 1) return; // must have at least 1
      onChange(current.filter(k => k !== key));
    } else {
      onChange([...current, key]);
    }
  };
  const current = access || ALL_PAGES.map(p => p.key);

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      {ALL_PAGES.map(pg => {
        const active = current.includes(pg.key);
        return (
          <button key={pg.key} onClick={() => toggle(pg.key)}
            style={{
              padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer",
              border: active ? `2px solid ${pg.color}` : "2px solid #E2E8F0",
              background: active ? `${pg.color}15` : "transparent",
              color: active ? pg.color : "#94A3B8",
              transition: "all 0.15s",
            }}
          >
            {active ? "✓ " : ""}{pg.label}
          </button>
        );
      })}
    </div>
  );
}
